// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NumberOutlinedSvg from "@ant-design/icons-svg/es/asn/NumberOutlined";
import AntdIcon from '../components/AntdIcon';

var NumberOutlined = function NumberOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: NumberOutlinedSvg
  }));
};

NumberOutlined.displayName = 'NumberOutlined';
export default React.forwardRef(NumberOutlined);